import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(marketing)/hero/index.tsx");
